import { render, staticRenderFns } from "./TehMessageAlert.vue?vue&type=template&id=1d5eddf7&scoped=true"
import script from "./TehMessageAlert.vue?vue&type=script&lang=js"
export * from "./TehMessageAlert.vue?vue&type=script&lang=js"
import style0 from "./TehMessageAlert.vue?vue&type=style&index=0&id=1d5eddf7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5eddf7",
  null
  
)

export default component.exports